import { useAction, useQuery } from "convex/react"
import { api } from "../convex/_generated/api.js"
import { useEffect, useState } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocationDot } from '@fortawesome/free-solid-svg-icons'
import ApplicantForm from './ApplicantForm.js'
import Sidebar from '../common/Sidebar.js'
import './ReferralList.css'

const ReferralList = () => {

    const referrals = useQuery(api.referrals.getReferrals)
    const [List,setList] = useState([])
    // eslint-disable-next-line no-unused-vars
    const [searchText, setSearchText] = useState("");
    const searchResults = useAction(api.referrals.filterReferrals);
    const currentUser = useQuery(api.users.getUser)
    const logo = 'https://logo.clearbit.com/'
   
    useEffect(() => {
        async function search () {
        const results = await searchResults({
          descriptionQuery: searchText
        });
        console.log("these are results "+results.map(r=>r.company))
        setList(results);
      }
        if(searchText.trim()==="") {
        setList(referrals)
        }
        else {
        search();
        console.log("referral list is filtered")
        }

    },[referrals,searchText])

    const handlefilter = (filter) =>{
      setSearchText(filter)
    }

    return (
        <div className="body">
        <Sidebar getSearchFilter = { handlefilter }/>
        <div className='cards'>
        <ul className='ul-class'>
          {List ? List.map(item => (
          
            <li key={item.email} className='li-class'>
              <div className='content'>
                  <div className='image'>
                  <div className="logo-container">
                    <img src={logo + item.company.toLowerCase() + '.com'}></img>
                  </div>
                  </div>
                  <div>
                  <br></br>
                  <span className='heading'>{item.name} works as <b>{item.jobRole}</b> at {item.company}</span>
                  <br></br>
                  <span className='heading'>can refer for</span>
                  <ul className='ul-yoe'>
                  { item.yoe.map(i => (
                    <li key={i} className='yoe'>{i}</li>
                  ))} 
                  </ul>
                  <FontAwesomeIcon icon={faLocationDot} className='location-icon'/><span className='location'>{item.location}</span>
                  </div>
              </div>
              
              <div className='apply-button'>
                <ApplicantForm id={item._id} userId={currentUser._id}/>
              </div>
            </li>
          )) : <div className="loader"></div>}
        </ul>
        </div>
      </div>
    )
}
export default ReferralList